module.exports = __webpack_public_path__ + "img/logo-minimized.1320bc14.png";